/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "comlambda",
            "endpoint": "https://5fdtmnq8d0.execute-api.us-east-1.amazonaws.com/bombay",
            "region": "us-east-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://qd3jevqqojhabnytzkroxpkpua.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-kn7yrzp4kfd53gfbfuz25ypvce",
    "aws_cognito_identity_pool_id": "us-east-1:c94b754a-8e92-4d5d-8fd6-9d02c63eaf14",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_M9aYJFpFZ",
    "aws_user_pools_web_client_id": "718soehao25o2qu5gv70gqtuif",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "indiancommerceb7ad235c646741149017fafd21e632fb172753-bombay",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
